import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogTitle,
  IconButton,
  Slide,
  TextField,
  Tooltip,
  Typography,
  LinearProgress,
  DialogContent,
} from "@mui/material";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  formatteDateDay,
  generateUniqueMatterName,
  pageScrollStyle,
} from "../../../styles/styles";
import DataTable from "../../DataTable";
import FilterListRoundedIcon from "@mui/icons-material/FilterListRounded";
import DeleteRoundedIcon from "@mui/icons-material/DeleteRounded";
import {
  GridToolbarColumnsButton,
  GridToolbarContainer,
  GridToolbarDensitySelector,
  GridToolbarExport,
} from "@mui/x-data-grid";
import NoDoc from "../../../assets/no-document.webp";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteDocItem,
  getAlldocCategory,
  getAllDocFolder,
} from "../../../redux/Apps/Lawyerapp/DocumentSlice/DocumentSlice";
import { backend_api } from "../../../static/server";
import { useNavigate } from "react-router-dom";
import TopicRoundedIcon from "@mui/icons-material/TopicRounded";
import DriveFileRenameOutlineRoundedIcon from "@mui/icons-material/DriveFileRenameOutlineRounded";
import { LoadingButton } from "@mui/lab";
import axios from "axios";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const CustomNoRowsOverlay = () => (
  <Box
    sx={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      p: "2rem",
      gap: "1rem",
    }}
  >
    <Box sx={{ height: "10rem" }}>
      <img
        src={NoDoc}
        alt="No Documents"
        style={{
          height: "100%",
          width: "100%",
          objectFit: "contain",
        }}
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = require("../../../assets/no-preview.webp");
        }}
      />
    </Box>
    <Typography variant="body1">No Document available.</Typography>
  </Box>
);

const CustomToolbar = () => {
  return (
    <GridToolbarContainer className="flex justify-end px-2 py-2">
      <div className="flex gap-2">
        <GridToolbarColumnsButton />
        <GridToolbarDensitySelector />
        <GridToolbarExport />
      </div>
    </GridToolbarContainer>
  );
};

const billFilters = [];

const Document = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [page, setPage] = useState(1);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [deleteProgress, setDeleteProgress] = useState(0);
  const [deleteStatus, setDeleteStatus] = useState("");
  const [totalItemsToDelete, setTotalItemsToDelete] = useState(0);
  const [processedItems, setProcessedItems] = useState(0);

  const { token, teamMemberLawyerId } = useSelector((data) => data.user);
  const { allDocFolder, loading } = useSelector((state) => state.document);
  const { pageSize, rowCount, nextPage, previousPage, count } = useSelector(
    (state) => state.document.docFoldersPagination
  );

  useEffect(() => {
    dispatch(
      getAllDocFolder({
        url: `${backend_api}documents/document/folder/?parent__isnull=true`,
        token: token,
        // page: page,
        // pageSize: pageSize,
        // teamMemberLawyerId: teamMemberLawyerId,
      })
    );
  }, [dispatch, token]);

  const handlePageChange = useCallback(
    (newPage) => {
      setPage(newPage);
      dispatch(
        getAllDocFolder({
          url: `${backend_api}documents/document/folder/?parent__isnull=true`,
          token,
          page: newPage,
          // pageSize: pageSize,
          // teamMemberLawyerId: teamMemberLawyerId,
        })
      );
    },
    [dispatch, token]
  );

  const handleEditFolder = useCallback((folder) => {
    console.log("Editing folder:", folder);
  }, []);

  const handleDeleteDialog = useCallback((folderId, folderName) => {
    if (folderId && folderName) {
      setSelectedFolder({ id: folderId, name: folderName });
      setOpenDeleteDialog(true);
      setDeleteProgress(0);
      setDeleteStatus("");
      setProcessedItems(0);
      setTotalItemsToDelete(0);
    }
  }, []);

  const countTotalItemsRecursively = useCallback(async (folderId, token) => {
    if (!folderId || !token) {
      console.error("Missing folderId or token");
      return 1;
    }

    try {
      const response = await axios.get(
        `${backend_api}documents/document/folder/${folderId}/`,
        {
          headers: {
            Authorization: `Token ${token}`,
          },
          timeout: 30000,
        }
      );

      if (response.status !== 200) {
        console.error(`Failed to fetch folder data: ${response.statusText}`);
        return 1;
      }

      const folderData = response?.data;
      let totalCount = 1;

      if (folderData?.documents && Array.isArray(folderData.documents)) {
        totalCount += folderData.documents.length;
      }

      if (folderData?.child_folder && Array.isArray(folderData.child_folder)) {
        for (const subfolder of folderData.child_folder) {
          if (subfolder?.id) {
            const subfolderCount = await countTotalItemsRecursively(
              subfolder.id,
              token
            );
            totalCount += subfolderCount;
          }
        }
      }

      return totalCount;
    } catch (error) {
      console.error(`Error counting items in folder ${folderId}:`, error);
      return 1;
    }
  }, []);

  const deleteFolderRecursively = useCallback(
    async (folderId, token) => {
      if (!folderId || !token) {
        throw new Error("Missing folderId or token");
      }

      try {
        const response = await axios.get(
          `${backend_api}documents/document/folder/${folderId}/`,
          {
            headers: {
              Authorization: `Token ${token}`,
            },
            timeout: 30000,
          }
        );

        if (response.status !== 200) {
          throw new Error(
            `Failed to fetch folder data: ${response?.statusText}`
          );
        }

        const folderData = response.data;
        if (folderData?.documents && Array.isArray(folderData.documents)) {
          for (const file of folderData.documents) {
            if (file?.id) {
              setDeleteStatus(`Deleting file: ${file.name || file.id}`);

              try {
                await dispatch(
                  deleteDocItem({
                    url: `${backend_api}documents/document/${file.id}/`,
                    token: token,
                  })
                ).unwrap();

                setProcessedItems((prev) => {
                  const newCount = prev + 1;
                  setDeleteProgress((newCount / totalItemsToDelete) * 100);
                  return newCount;
                });
              } catch (fileError) {
                console.error(`Error deleting file ${file.id}:`, fileError);
              }
            }
          }
        }

        if (
          folderData?.child_folder &&
          Array.isArray(folderData.child_folder)
        ) {
          for (const subfolder of folderData.child_folder) {
            if (subfolder?.id) {
              setDeleteStatus(
                `Processing subfolder: ${
                  subfolder?.folder_name || subfolder.id
                }`
              );
              await deleteFolderRecursively(subfolder.id, token);
            }
          }
        }

        setDeleteStatus(
          `Deleting folder: ${folderData?.folder_name || folderId}`
        );

        await dispatch(
          deleteDocItem({
            url: `${backend_api}documents/document/folder/${folderId}/`,
            token: token,
          })
        ).unwrap();

        setProcessedItems((prev) => {
          const newCount = prev + 1;
          setDeleteProgress((newCount / totalItemsToDelete) * 100);
          return newCount;
        });
      } catch (error) {
        console.error(`Error deleting folder ${folderId}:`, error);
        throw error;
      }
    },
    [dispatch, totalItemsToDelete]
  );

  const handleDeleteFolder = useCallback(async () => {
    if (!selectedFolder?.id || !token) {
      console.error("Missing required data for deletion");
      return;
    }

    try {
      setDeleteLoading(true);
      setDeleteProgress(0);
      setProcessedItems(0);
      setDeleteStatus("Analyzing folder structure...");

      const totalCount = await countTotalItemsRecursively(
        selectedFolder.id,
        token
      );
      setTotalItemsToDelete(totalCount);

      setDeleteStatus("Starting deletion process...");

      await deleteFolderRecursively(selectedFolder.id, token);

      setDeleteStatus("Deletion completed successfully!");
      setDeleteProgress(100);

      setTimeout(() => {
        dispatch(
          getAllDocFolder({
            url: `${backend_api}documents/document/folder/?parent__isnull=true`,
            token: token,
            page: page,
            pageSize: pageSize,
            teamMemberLawyerId: teamMemberLawyerId,
          })
        ).catch((error) => {
          console.error("Error refreshing folders:", error);
        });

        setOpenDeleteDialog(false);
        setSelectedFolder(null);
        setDeleteProgress(0);
        setDeleteStatus("");
        setProcessedItems(0);
        setTotalItemsToDelete(0);
      }, 1500);
    } catch (error) {
      console.error("Error deleting folder:", error);
      setDeleteStatus(`Error: ${error.message || "Unknown error occurred"}`);
    } finally {
      setDeleteLoading(false);
    }
  }, [
    selectedFolder,
    dispatch,
    token,
    page,
    pageSize,
    teamMemberLawyerId,
    countTotalItemsRecursively,
    deleteFolderRecursively,
  ]);

  const handleSearchChange = useCallback((event) => {
    setSearchTerm(event.target.value);
  }, []);

  const handleOpenFolder = useCallback(
    (row) => {
      if (row?.id && row?.folder_name) {
        navigate(`/dashboard/documents/folder/${row.id}-${row.folder_name}/`);
      }
    },
    [navigate]
  );

  const handleCloseDeleteDialog = useCallback(() => {
    if (!deleteLoading) {
      setOpenDeleteDialog(false);
      setSelectedFolder(null);
      setDeleteProgress(0);
      setDeleteStatus("");
      setProcessedItems(0);
      setTotalItemsToDelete(0);
    }
  }, [deleteLoading]);

  const columns = useMemo(
    () => [
      {
        field: "action",
        headerName: "Actions",
        width: 150,
        sortable: false,
        renderCell: (params) => (
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
              gap: "0.2rem",
              width: "100%",
            }}
          >
            <Tooltip title="Open folder">
              <IconButton
                size="small"
                aria-label="open folder"
                color="primary"
                onClick={() => handleOpenFolder(params.row)}
              >
                <TopicRoundedIcon sx={{ fontSize: "1rem" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Edit">
              <IconButton
                color="primary"
                size="small"
                aria-label="edit folder"
                onClick={() => handleEditFolder(params.row)}
              >
                <DriveFileRenameOutlineRoundedIcon sx={{ fontSize: "1rem" }} />
              </IconButton>
            </Tooltip>
            <Tooltip title="Delete">
              <IconButton
                color="error"
                size="small"
                aria-label="delete folder"
                onClick={() =>
                  handleDeleteDialog(params.id, params.row.folder_name)
                }
              >
                <DeleteRoundedIcon sx={{ fontSize: "1rem" }} />
              </IconButton>
            </Tooltip>
          </Box>
        ),
      },
      {
        field: "folder_name",
        headerName: "Folder Name",
        width: 200,
        flex: 1,
      },
      {
        field: "category",
        headerName: "Category",
        width: 150,
      },
      {
        field: "client",
        headerName: "Contact",
        width: 150,
      },
      {
        field: "matter",
        headerName: "Matter",
        width: 150,
      },
      {
        field: "file_folderCount",
        headerName: "Folders and files",
        width: 150,
        flex: 1,
      },
      {
        field: "created_at",
        headerName: "Folder Create At",
        width: 150,
        flex: 1,
      },
    ],
    [handleOpenFolder, handleEditFolder, handleDeleteDialog]
  );

  const rows = useMemo(() => {
    if (!Array.isArray(allDocFolder)) {
      console.error("allDocFolder is not an array:", allDocFolder);
      return [];
    }

    let filteredData = allDocFolder;

    if (searchTerm.trim()) {
      filteredData = allDocFolder.filter((item) => {
        const folderNameMatch = item?.folder_name
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
        const categoryMatch = item?.category?.category_name
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());
        const commentsMatch = item?.comments
          ?.toLowerCase()
          .includes(searchTerm.toLowerCase());

        return folderNameMatch || categoryMatch || commentsMatch;
      });
    }

    return filteredData.map((item) => ({
      id: item?.id,
      folder_name: item?.folder_name ?? "--",
      category: item?.category?.category_name ?? "-",
      client: item?.client
        ? `${item?.case?.case_related_person?.first_name} ${item?.case?.case_related_person?.last_name}`
        : item?.case && item?.case?.case_related_person
        ? `${item?.case?.case_related_person?.first_name} ${item?.case?.case_related_person?.last_name}`
        : "-",
      matter: item?.case
        ? generateUniqueMatterName(item?.case?.id, item?.case?.case_name)
        : "-",
      file_folderCount: (() => {
        const folderCount = Array.isArray(item?.child_folder)
          ? item.child_folder.length
          : 0;
        const fileCount = Array.isArray(item?.documents)
          ? item.documents.length
          : 0;
        return `folders ${folderCount} - files ${fileCount}`;
      })(),
      created_at: item?.created_at ? formatteDateDay(item.created_at) : "-",
    }));
  }, [allDocFolder, searchTerm]);

  return (
    <>
      <div className="w-full">
        <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
          <Box
            className="bg-white rounded-lg justify-between h-[80vh] p-2 w-full shadow-lg"
            sx={{ ...pageScrollStyle, overflow: "auto" }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: "0.8rem",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: "0.8rem",
                  }}
                >
                  {billFilters?.length > 0 && (
                    <Box
                      sx={{
                        display: "flex",
                        gap: "0.5rem",
                        p: "0.2rem",
                        borderRadius: "0.5rem",
                        border: "1px solid #e5e5e5",
                      }}
                    >
                      {billFilters?.map((item, i) => (
                        <Button
                          key={i}
                          variant="text"
                          sx={{
                            textTransform: "capitalize",
                            fontSize: "0.8rem",
                          }}
                        >
                          {item}
                        </Button>
                      ))}
                    </Box>
                  )}
                </Box>
                <Box sx={{ display: "flex", gap: "1rem" }}>
                  <TextField
                    size="small"
                    placeholder="Search folders..."
                    className="flex-1"
                    label="Search"
                    value={searchTerm}
                    onChange={handleSearchChange}
                    sx={{ width: "15rem" }}
                  />
                  <Button
                    variant="outlined"
                    color="primary"
                    startIcon={<FilterListRoundedIcon />}
                  >
                    Filter
                  </Button>
                </Box>
              </Box>

              <Box>
                <DataTable
                  columns={columns}
                  rows={rows}
                  CustomToolbar={CustomToolbar}
                  CustomNoRowsOverlay={CustomNoRowsOverlay}
                  loading={loading}
                  page={page}
                  setPage={setPage}
                  pageSize={pageSize}
                  rowCount={rowCount}
                  count={count}
                  onPageChange={handlePageChange}
                  hasNextPage={nextPage !== null}
                  hasPreviousPage={previousPage !== null}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </div>

      {/* Delete Confirmation Dialog */}
      <Dialog
        open={openDeleteDialog}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleCloseDeleteDialog}
        maxWidth="sm"
        fullWidth
        disableEscapeKeyDown={deleteLoading}
      >
        <DialogTitle>
          {selectedFolder
            ? `Delete "${selectedFolder.name}"?`
            : "Delete Folder"}
        </DialogTitle>

        <DialogContent>
          {!deleteLoading ? (
            <Box>
              <Typography variant="body2" color="text.secondary">
                This action will permanently delete:
              </Typography>
              <Box sx={{ mt: 1, ml: 2 }}>
                <Typography variant="body2" color="error">
                  • The folder "{selectedFolder?.name}"
                </Typography>
                <Typography variant="body2" color="error">
                  • All files inside this folder
                </Typography>
                <Typography variant="body2" color="error">
                  • All subfolders and their contents (recursively)
                </Typography>
              </Box>
              <Typography
                variant="body2"
                color="text.secondary"
                sx={{ mt: 1, fontWeight: "bold" }}
              >
                This action cannot be undone.
              </Typography>
            </Box>
          ) : (
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {deleteStatus}
              </Typography>
              <LinearProgress
                variant="determinate"
                value={deleteProgress}
                sx={{ mb: 1 }}
              />
              <Typography variant="caption" color="text.secondary">
                {processedItems} of {totalItemsToDelete} items processed (
                {Math.round(deleteProgress)}%)
              </Typography>
            </Box>
          )}
        </DialogContent>

        <DialogActions>
          <Button
            size="small"
            variant="outlined"
            color="primary"
            onClick={handleCloseDeleteDialog}
            disabled={deleteLoading}
          >
            Cancel
          </Button>
          <LoadingButton
            loading={deleteLoading}
            size="small"
            color="error"
            variant="contained"
            onClick={handleDeleteFolder}
          >
            Delete All
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default Document;
